import React from 'react'
import styled from '@emotion/styled'

import { fontFamilyOpenSans, grayLight10 } from '../../constants/principles'
import { BrowserUtils } from '../../utils/siteUtils'
import Tab from './tab'

export default ({ children, activeTab, onClickTabItem, isImage, displayArrow, tabPrimary, bodyStyle, make, model }) => {
  const realChildren = children.filter(x => !!x)
  const isDesktop = BrowserUtils.isDesktop()

  return (
    <>
      <StyledOl displayArrow={displayArrow} isDesktop={isDesktop}>
        {realChildren.map(({ props: { label, testId } }, index) => (
          <Tab
            key={index}
            isActive={activeTab === label}
            label={label}
            testId={testId}
            onClick={e => (e && e.preventDefault()) || onClickTabItem(label)}
            isImage={isImage}
            displayArrow={displayArrow}
            tabPrimary={tabPrimary}
            bodyStyle={bodyStyle}
            make={make}
            model={model}
          />
        ))}
      </StyledOl>
      {realChildren.find(child => child.props.label === activeTab)}
      {/* {realChildren.map(child => child.props.label !== activeTab && <StyledDiv key={child.props.label}>{child}</StyledDiv>)} */}
    </>
  )
}

const StyledOl = styled.ol`
  ${p =>
    !p.displayArrow
      ? `
        font-family: ${fontFamilyOpenSans};
        padding-left: 0;
        display: flex;
        justify-content: center;
        cursor: pointer;
        margin-top: 0;
        margin-bottom: 10.5px;`
      : `
        font-family: ${fontFamilyOpenSans};
        padding: ${!p.isDesktop ? 'unset' : '0 195px 0 180px'};
        display: flex;
        justify-content: center;
        cursor: pointer;
        margin-bottom: 30px;
        width: 110%;
        margin-left: -20px;
  `}
`
